searchHandler = {
    $startSearch : $('.start-search'),
    $textSearch : $('.text-search'),
    $textSearchCell : $('.text-search-cell'),
    $suggestPanel : $('#suggest-panel'),
    $defaultSuggest : $('#default-suggest'),
    $searchedSuggest : $('#searched-suggest'),
    $listSearched : $('.list-searched'),
    $smallTxtSearch : $('.small-txt-search'),
    $closePanelSearch : $('[href=#close-panel-search]'),
    $panelSuggestContainer : $('.panel-suggest-container'),
    $html : $('html'),
    isLoad: false,
    $collImage: $('.coll-image'),
    indexHtml: '',

    setSuggest : function($obj, showSuggestSearched = false){
        var self = this;
        var text = $obj.val();

        if (text.length < 2) {
            if (showSuggestSearched == false) {
                self.$defaultSuggest.addClass('active');

                if (Foundation.MediaQuery.only('small'))
                    $('.accessibility-widgets-container').hide();
            }
            self.$searchedSuggest.removeClass('active');
        } else {
            self.$searchedSuggest.addClass('active');     
            self.$defaultSuggest.removeClass('active');
            if (Foundation.MediaQuery.only('small'))
                $('.accessibility-widgets-container').show();   
        }
        //ajax request here
        self.lookupSuggestion(text, $obj);    
    },

    strToUpper: function(str) {
        var res = str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
            return letter.toUpperCase();
        });
        return res; 
    },

    lookupSuggestion: function(val, $obj) {
		var self = this;
        val = val.toLowerCase();
        if (!$obj.parent().hasClass('left-panel-mode')) {
            self.$listSearched.children().removeClass('active').removeClass('last-suggest-category');
            if (val.length >= 2) {
                var isDataAvailable = false; 
                var $activeObj = null;
                self.$listSearched.children().each(function(){
                    var nm = $(this).data('name');
                    if (nm) {
                        var nmLower = nm.toLowerCase();
                        if (nmLower.indexOf(val) > -1) {
                            var char       = '<span class="highlight color-black">' + val.toLowerCase() + '</span>';
                            var char2      = '<span class="highlight color-black">' + self.strToUpper(val) + '</span>';
                            var newText    = nm.replace(val.toLowerCase(), char);
                            newText        = newText.replace(self.strToUpper(val), char2);
                            
                            $(this).addClass('active');
                            var $name = $(this).find('.name');
                            if ($name) {
                                $name.html(newText);
                            }
                            isDataAvailable = true;
                            $activeObj = $(this);
                        }
                    }
                });
                if (isDataAvailable == false) {
                    self.$listSearched.find('.empty').addClass('active');
                } else {
                    $activeObj.addClass('last-suggest-category');
                }
            }
        } else {
            $filterLlistContainer = $($obj.parent().parent().next()[0]);
            $filterLlistContainer.children().addClass('hide');
            
            var isDecade = $filterLlistContainer.closest('.accordion-content').hasClass('type-decade');
            var $submitButton = $filterLlistContainer.siblings('button[type="submit"]')
            var hasResults = false;
            $submitButton.addClass('hide')

            if (val.length >= 2) {
                $filterLlistContainer.children().each(function(){
                    var $input = $(this).find('input');
                    if (isDecade) {
                        var name = $input.data('year');
                    } else {
                        var name = $input.attr('name');
                    }
                    if (name.length > 0) {
                        name = name.toLowerCase(); 
                        if (name.indexOf(val) > -1) {
                            $(this).removeClass('hide');
                            hasResults = true
                        }
                    }
                });

                if (hasResults) {
                    $submitButton.removeClass('hide')
                }
            }
        }
	},

    closePanelSearch: function(){
        this.$suggestPanel.removeClass('active');
        this.$defaultSuggest.removeClass('active');
        this.$searchedSuggest.removeClass('active');
        if (Foundation.MediaQuery.only('small'))
            $('.accessibility-widgets-container').show();   
    },

    doRedirectSearch: function(text) {
        this.setCookieSearchParams('text', text);
        if (window.location.pathname.indexOf("index") < 0) {
            // window.location.pathname = 'index?search-query=' + text;
            window.location.href = '/collection?search-query=' + text;
        }
        this.closePanelSearch();
        this.loadData();
    },

    setCookieSearchParams: function(type, value, isRemove = false){
        var arrFilters = [];
        var item = {};
        var arrVal = [];
        var addNewItem = false;
        
        var tmp = Cookies.get('filters');
        if ((tmp != undefined) && (tmp != null) && (tmp != "")) {
            if (Object.keys(tmp).length > 0) {
                JSON.parse(tmp).forEach(e => {
                    if (e != null) {       
                        if (e.value != null) {
                            arrVal = JSON.parse(JSON.stringify(e.value));
                        }   
                        item = {};
                        item.type  = e.type;
                        item.value = arrVal;

                        if (type == e.type) {
                            if (arrVal.indexOf(value) < 0) {
                                arrVal.push(value);
                            }

                            if (isRemove) {
                                arrVal.splice(arrVal.indexOf(value), 1);
                            }

                            if ((type == 'text') || (type == 'page_index')) {
                                arrVal = [];
                                arrVal.push(value);
                            }
                                               
                            item.value = arrVal;
                        } else {
                            var isExist = false; 
                            JSON.parse(tmp).forEach(itm => {
                                if (itm.type == type) {
                                    isExist = true;
                                }
                            });

                            if ((!isExist) && (!isRemove)) {
                                addNewItem = true;
                            }                        
                        }

                        arrFilters.push(item);                              
                    }
                })
            }
        } else {
            addNewItem = true;
        }

        if (addNewItem) {
            var arrNewVal = [];
            var newItem = {};
            arrNewVal.push(value);

            newItem.type  = type;
            newItem.value = arrNewVal;
            arrFilters.push(newItem);
        }
        
        Cookies.set('filters', JSON.stringify(arrFilters));
    },

    loadData: function(setTextSearch=false, setDisplaySelected=false, setCountOnly=false){
        var self = this;
        var tmp = Cookies.get('filters');
        var $page_index = '1';
        var $sort_field = '';
        var $sort_order = '';
        var $filter_designer = '';
        var $filter_country  = '';
        var $filter_keyword  = '';
        var $filter_decade 	 = '';
        var $filter_text     = '';

        if ((tmp != undefined) && (tmp != null) && (tmp != "")) {
            if (Object.keys(tmp).length > 0) {
                JSON.parse(tmp).forEach(e => {
                    if (e.type == 'page_index') {
                        $page_index = e.value[0];
                    }
                    
                    if (e.type == 'sort_field') {
                        e.value.forEach(element => {
                            if (element) {
                                $sort_field = element
                            }
                        });
                    }

                    if (e.type == 'sort_order') {
                        $sort_order = e.value[0];
                    }

                    if (e.type == 'designer') {
                        // for (let index = 0; index < e.value.length; index++) {
                        //     $filter_designer += ($filter_designer ? ',' : '') + e.value[index];
                        // }
                        $filter_designer = e.value;
                    }

                    if (e.type == 'country') {
                        $filter_country = e.value;
                    }
                    
                    if (e.type == 'keyword') {
                        $filter_keyword = e.value;
                    }

                    if (e.type == 'decade') {
                        $filter_decade = e.value;
                    }

                    if (e.type == 'text') {
                        $filter_text = e.value[0];
                    }
                })
            }
        } else {
            indexHandler.$filterResult.removeClass('is-show');
            indexHandler.$filterResult.find('.result-text').attr('tabindex', '-1');
            indexHandler.$filterResult.find('.reset-button').attr('tabindex', '-1');
        }
        
        if (setTextSearch == true) {
            self.$textSearch.each(function(){
                if (!$(this).closest('.input-text-search-style').hasClass('left-panel-mode')){
                    $(this).val($filter_text);
                }
            })
        }

        if (!setCountOnly) {
            indexHandler.$indexContainer.find('.panel-content-index').empty();
            indexHandler.$indexContainer.find('.panel-content-index').addClass('loading-container');
        }

        if (setDisplaySelected) {
            self.setDisplaySelectedFilter($filter_designer, $filter_country, $filter_keyword, $filter_decade );
        }

        if ($filter_text !== '') { 
            indexHandler.$filterResult.addClass('is-show');
        } 

        if (!setCountOnly && self.indexHtml) {
            indexHandler.$indexContainer.find('.panel-content-index').replaceWith(self.indexHtml);
            indexHandler.reinitializeMasonry();
            self.indexHtml = '';
        } else if (self.isLoad == false) {
            $.ajax({
                type: 'post',
                url: myAjax.ajax_url,
                data: {
                    action     : 'load_index_paging',
                    page_index : $page_index,
                    sort_field : $sort_field,
                    sort_order : $sort_order,
                    filter_designer : $filter_designer,
                    filter_country  : $filter_country,
                    filter_keyword  : $filter_keyword,
                    filter_decade 	: $filter_decade,
                    filter_text     : $filter_text
                },
                beforeSend: function() {
                    if (!setCountOnly) {
                        self.$html.addClass('loading');
                        self.isLoad = true;
                        indexHandler.$indexContainer.find('.panel-content-index').empty();
                    }

                    indexHandler.$resultCount.html('');
                    indexHandler.$resultSuffix.html('');
                    indexHandler.$resultText.addClass('hide');
                },  
                success: function(response) {
                    let $resultHtml = response['html'];
                    if (!setCountOnly) {
                        indexHandler.$indexContainer.find('.panel-content-index').replaceWith($resultHtml);
                        indexHandler.reinitializeMasonry();
                        self.$html.removeClass('loading');
                        self.isLoad = false;
                    } else {
                        self.indexHtml = $resultHtml;
                    }

                    var itemCount = $($resultHtml).data('all-count');
                    
                    if (itemCount > 0) {
                        indexHandler.$resultText.removeClass('hide');
                        indexHandler.$resultCount.html(itemCount);

                        if (itemCount > 1)
                            indexHandler.$resultSuffix.html('s');
                    }

                    clearTimeout(indexHandler.loadTimeout);
                    indexHandler.loadTimeout = null;
                },
            });
        }
    },

    setDisplaySelectedFilter: function($filter_designer, $filter_country, $filter_keyword, $filter_decade ){
        if ($filter_designer) {
            $filter_designer.forEach(element => {
                let $obj = $("[value='"+element+"']");
                $obj.prop('checked', true);
                indexHandler.generateCloseItem($obj);
            });
        }
        if ($filter_country) {
            $filter_country.forEach(element => {
                let $obj = $("[value='"+element+"']");
                $obj.prop('checked', true);
                indexHandler.generateCloseItem($obj);
            });
        }
        if ($filter_keyword) {
            $filter_keyword.forEach(element => {
                let $obj = $("[value='"+element+"']");
                $obj.prop('checked', true);
                indexHandler.generateCloseItem($obj);
            });
        }
        if ($filter_decade) {
            $filter_decade.forEach(element => {
                let $obj = $("[value='"+element+"']");
                $obj.prop('checked', true);
                indexHandler.generateCloseItem($obj);
            });
        }
    },

    init: function(){
        var self = this;
        if ( ((window.location.pathname.indexOf("index") < 0) && (window.location.pathname.indexOf("/poster/") < 0)) || (stateClearFilter)) {
            Cookies.set('filters', "");
        } else {
            // setTimeout(() => {
            //     this.loadData(true);    
            // }, 2000);
        }

        $(document).on('focusout', '.last-suggest-category', function(){
        //self.$panelSuggestContainer.find('.last-suggest-category, .item.active:last-of-type').on('focusout', function(e) {
            self.$suggestPanel.removeClass('active');
            self.setSuggest('', false);
        });
        
        this.$startSearch.on('click', function(e){
            e.preventDefault();      
            var text = $($(this).prev()).val();
            if ((text.length > 2) || (text == '')) {
                self.doRedirectSearch(text);
            } 
        })

        this.$textSearch.on('focus', function(){
            var showSuggest = $(this).data('show-suggest');
            var showSuggestSearched = $(this).data('show-suggest-searched');
            if ((showSuggest == true) || (showSuggestSearched == true)) {
                self.$suggestPanel.addClass('active');
                self.setSuggest($(this), showSuggestSearched);
            }
        })
        // .blur(function(){
        //     var showSuggest = $(this).data('show-suggest');
        //     var showSuggestSearched = $(this).data('show-suggest-searched');
        //     if (((showSuggest == true) || (showSuggestSearched == true)) && ($('html.no-touchevents').length > 0)) {
        //         setTimeout(() => {
        //             self.closePanelSearch();
        //         }, 500);
        //     }
        // });
        // .on('keydown', function(e) {
        //     var showSuggest = $(this).data('show-suggest');
        //     var showSuggestSearched = $(this).data('show-suggest-searched');

        //     // When pressing arrow down, switch focus to the first active item inside suggestion panel
        //     if ((showSuggest == true) && e.key == 'ArrowDown') {
        //         console.log(self.$panelSuggestContainer.children('.suggest.active').find('a:first, .item.active:first a').get(0))
        //         self.$panelSuggestContainer.children('.suggest.active').find('a:first, .item.active:first a').get(0).focus()
        //         e.preventDefault();
        //     }
        // });

        // Keyboard event for suggestion panel
        this.$panelSuggestContainer.on('keydown', function(e) {
            // Close the panel when Esc key pressed
            if (e.key === 'Escape') {
                self.$panelSuggestContainer.removeClass('active')
            }
        });

        // Outside click of panelSuggestContainer, close the search panel
        $(window).on('click', function(e) {
            if (!self.$panelSuggestContainer.is(e.target)
                && self.$panelSuggestContainer.has(e.target).length === 0
                && !self.$textSearchCell.is(e.target)
                && self.$textSearchCell.has(e.target).length === 0)
            {
                self.closePanelSearch();
            }
        });

        // Keyboard event for listSearched item. User can use arrow key to navigate the item
        self.$listSearched.on('keydown', '.item', function(e) {
            var $el = $(this)

            switch (e.key) {
                case 'ArrowUp':
                    var $prev = $el.prevAll('.active:first')
                    if ($prev.length > 0) {
                        $prev.find('a').get(0).focus()
                    }
                    e.preventDefault()
                    break;

                case 'ArrowDown':
                    var $next = $el.nextAll('.active:first')
                    if ($next.length > 0) {
                        $next.find('a').get(0).focus()
                    }
                    e.preventDefault()
                    break;
            }
        })

        this.$textSearch.on('input', function(){
            var showSuggestSearched = $(this).data('show-suggest-searched');
            self.setSuggest($(this), showSuggestSearched);

            // var text = $(this).val();
            // if (text.length === 1) {
            //     var showSuggest = $(this).data('show-suggest');
            //     var showSuggestSearched = $(this).data('show-suggest-searched');
            //     if ((showSuggest == true) || (showSuggestSearched == true)) {
            //         self.$suggestPanel.addClass('active');
            //         self.setSuggest($(this), showSuggestSearched);
            //     }
            // }
        }).keyup(function(e){
            var text = $(this).val();
            var dataLeftPanel = $(this).data('left-panel');

            if ((e.keyCode == 13) && (text.length > 0) || (e.keyCode == 13) && (text == '')) {
                self.doRedirectSearch(text);
            } 
            
            if ((dataLeftPanel == true) && (text == '')) {
                var $parentsSearch = $(this).closest('.search-box-container');
                if ($parentsSearch) {
                    $parentsSearch.next().children().removeClass('hide');
                    $parentsSearch.siblings('button[type="submit"]').removeClass('hide');
                }

                if ($(this).hasClass('see-all')) {
                    $parentsSearch.parent().find('.list-item-container').addClass('hide');
                    $parentsSearch.siblings('button[type="submit"]').addClass('hide');
                }
                
            }
        });       

        this.$smallTxtSearch.on('click', function(e){
            self.$suggestPanel.addClass('active');
            self.$defaultSuggest.addClass('active');
            self.$searchedSuggest.removeClass('active');
        })

        this.$closePanelSearch.on('click', function(e){
            self.closePanelSearch();
        })

        $('.panel-suggest-skip').on('click', function() {
            self.closePanelSearch();
        });
    }
}